<template>
  <div class="content" v-if="rendered">
    <div class="row mt-5">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="text-left col-12 pl-0">
            <h6>Cartões ativos - {{ table.length }}</h6>
          </div>
          <div class="barra-pesquisa-fixa">
            <div class="row space-between">
              <div class="search-container col-lg-4 col-md-4 pl-0">
                <base-input
                  v-model="searchQuery"
                  placeholder="Pesquisar..."
                  class="mb-3"
                  @input="filterTable"
                ></base-input>
              </div>
              <div class="col-lg-2 col-md-2 pl-0">
                <base-button
                  @click="exportToXlsx"
                  native-type="submit"
                  type="primary"
                  size="sm"
                  block
                >
                  Exportar
                </base-button>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <base-table :data="filteredTable" thead-classes="text-primary">
              <template slot="columns">
                <th class="text-left">Nome</th>
                <th class="text-left">NIF</th>
                <th class="text-left">Telefone</th>
                <th class="text-left">Email</th>
                <th class="text-left">Género</th>
                <th class="text-left">Data de Nascimento</th>
                <!-- <th class="text-left">Idade</th> -->
                <th class="text-left">QR Code</th>
                <th class="text-left">Desconto (%)</th>
                <th class="text-left">Source</th>
                <th class="text-left">Ações</th>
              </template>

              <template slot-scope="{ row, index }">
                <td class="text-left">{{ row.nome }}</td>
                <td class="text-left">{{ row.nif }}</td>
                <td class="text-left">
                  {{ row.telefone }}
                </td>
                <td class="text-left">{{ row.email }}</td>
                <td class="text-left">{{ row.sexo }}</td>
                <td class="text-left">{{ row.data_nascimento }}</td>
                <td class="text-left">{{ row.qr_code }}</td>
                <td class="text-left">
                  <div class="row centrarVerticalmente">
                    <div class="col-8">
                      <base-input
                        name="notificacao"
                        v-model="row.desconto"
                        type="textarea"
                        placeholder="Notificação"
                      ></base-input>
                    </div>
                    <div v-if="Number(row.desconto) != 10" class="col-4">
                      <i
                        class="tim-icons icon-alert-circle-exc"
                        style="color:red; font-weight:700;font-size:18px;"
                      ></i>
                    </div>
                  </div>
                </td>
                <td class="text-left">
                  {{ !row.utm_campaign ? "ORG" : row.utm_campaign }}
                </td>
                <td class="text-left">
                  <div class="row" style="flex-wrap: nowrap !important;">
                    <div class="col">
                      <i
                        @click="atualizarDesconto(row)"
                        class="tim-icons icon-check-2 pointer"
                        style="color:green;font-size:18px;"
                      ></i>
                    </div>
                    <div class="col">
                      <i
                        @click="sincronizarDescontoEmail(row)"
                        class="tim-icons icon-refresh-02 pointer"
                        style="color:red;font-size:18px;"
                      ></i>
                    </div>
                    <div class="col">
                      <i
                        @click="apagarCartao(row)"
                        class="tim-icons icon-trash-simple pointer"
                        style="color:red;font-size:18px;"
                      ></i>
                    </div>
                  </div>
                </td>
              </template>
            </base-table>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up"></h4>
      <div class="row text-left">
        <h4 style="font-weight:bold">Descontos na Zonesoft</h4>
      </div>
      <div class="col-12 text-left" style="padding-left:0px">
        <p v-for="(item, i) in clienteZoneSoft" :key="i">
          <span class="restaurante">{{ item.restaurante }}</span> :
          <span class="desconto">{{ item.desconto }} %</span> -
          <span class="text-green"> Atualizado</span>
        </p>
      </div>
    </modal>
  </div>
  <div v-else>
    <div class="loading-overlay">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
  </div>
</template>
<script>
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { Card, DropDown, Modal, BaseInput } from "@/components/index";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import TaskList from "./Dashboard/TaskList";
import config from "@/config";
import StatsCard from "@/components/Cards/StatsCard";
import api from "../api/index";
import { BaseTable, BaseProgress } from "@/components";
import { Table, TableColumn } from "element-ui";
import PieChart from "@/components/Charts/PieChart";
import swal from "sweetalert2";
export default {
  components: {
    Card,
    StatsCard,
    LineChart,
    BarChart,
    BaseInput,
    TaskList,
    Modal,
    BaseTable,
    BaseProgress,
    PieChart,
    // eslint-disable-next-line vue/no-unused-components
    [Table.name]: Table,
    // eslint-disable-next-line vue/no-unused-components
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      rendered: false,
      searchQuery: "",
      cartoes_original: [],
      table: [],
      filteredTable: [],
      topEscolhido: 2,
      faturacao: 0,
      consumo: [],
      clienteZoneSoft: [],
      restaurante: "",
      modals: {
        classic: false,
      },
    };
  },
  computed: {
    enableRTL() {
      return this.$route.query.enableRTL;
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
  methods: {
    async sincronizarDescontoEmail(array) {
      this.rendered = false;
      var json = {
        desconto: array.desconto,
        qr_code: array.qr_code,
        email: array.email,
      };
      let res = await api.sincronizarContacto(json);
      if (res.resultado && typeof res.resultado === "string") {
        this.clienteZoneSoft = JSON.parse(res.resultado);
        this.modals.classic = true;
      }
      setTimeout(() => {
        this.rendered = true;
      }, 1000);
    },
    async atualizarDesconto(array) {
      let desconto = Number(array.desconto);
      if (isNaN(desconto)) {
        alert("Tem de ser um numero");
        return;
      }
      if (desconto < 0 || desconto > 100) {
        alert("O desconto tem de ser entre 0 e 100 %");
        return;
      }
      var array_original = Object.values(this.cartoes_original).find(
        (x) => x.id == array.id
      );
      if (array.desconto === array_original.desconto) {
        alert("O desconto é igual");
        return;
      }
      let json = {
        desconto: array.desconto,
        qr_code: array.qr_code,
        apagar: 0,
      };
      let res = await api.atualizarDescontos(json);
      this.inicio();
      this.notifyVue(
        "top",
        "right",
        "success",
        "Desconto atualizado com sucesso."
      );
    },
    notifyVue(verticalAlign, horizontalAlign, color, mensagem) {
      this.$notify({
        icon: "tim-icons icon-bell-55",
        message: mensagem,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        timeout: 2000,
      });
    },
    async apagarCartao(array) {
      var _this = this;
      swal({
        title: "Atenção!",
        text: "Esta ação é irreversível",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, apagar!",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.dismiss) {
          return;
        }
        let json = {
          desconto: "0",
          qr_code: array.qr_code,
          apagar: 1,
        };
        let res = await api.atualizarDescontos(json);
        _this.filteredTable = _this.filteredTable.filter(
          (item) => item !== array
        );
        _this.notifyVue(
          "top",
          "right",
          "success",
          "Cartão removido com sucesso."
        );

        _this.inicio();
      });

      // let desconto = Number(array.desconto);
      // if (isNaN(desconto)) {
      //   alert("Tem de ser um numero");
      //   return;
      // }
      // if (desconto < 0 || desconto > 100) {
      //   alert("O desconto tem de ser entre 0 e 100 %");
      //   return;
      // }
      // var array_original = Object.values(this.cartoes_original).find(
      //   (x) => x.id == array.id
      // );
      // if (array.desconto === array_original.desconto) {
      //   alert("O desconto é igual");
      //   return;
      // }
      // let json = {
      //   desconto: array.desconto,
      //   qr_code: array.qr_code,
      // };
      // let res = await api.atualizarDescontos(json);
      // console.log(res);
    },

    capitalizeFirstLetter(text) {
      if (!text) return text;
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    filterTable() {
      const query = this.searchQuery.toLowerCase();
      this.filteredTable = this.table.filter((row) => {
        return (
          row.nome.toLowerCase().includes(query) ||
          row.nif.toLowerCase().includes(query) ||
          row.telefone.toLowerCase().includes(query) ||
          row.email.toLowerCase().includes(query) ||
          row.qr_code.toLowerCase().includes(query) ||
          (row.utm_campaign || "ORG").toLowerCase().includes(query)
        );
      });
    },
    async inicio() {
      this.rendered = false;
      var user = JSON.parse(localStorage.getItem("appGerenciaLogin"));
      let resUser = await api.listarRestaurante({
        user_id: user.user_id,
      });

      if (!localStorage.getItem("gerenciaTopEscolhido")) {
        this.topEscolhido = 5;
        // localStorage.setItem("gerenciaTopEscolhido", periodo_meses);
      } else {
        this.topEscolhido = localStorage.getItem("gerenciaTopEscolhido");
      }
      this.restaurante = resUser.resultado.nome;
      this.table = [];
      let cartoes = await api.buscarTodosCartoesCriados();
      var cartoes_array = Object.values(cartoes.resultado).sort(
        (a, b) => new Date(b.dt_created) - new Date(a.dt_created)
      );
      this.cartoes_original = JSON.parse(JSON.stringify(cartoes.resultado));

      for (let i = 0; i < cartoes_array.length; i++) {
        this.table.push(cartoes_array[i]);
      }

      this.rendered = true;

      return;
    },

    exportToXlsx() {
      var _this = this;
      // Definir os headers desejados
      const headers = [
        "Nome",
        "NIF",
        "Telefone",
        "Email",
        "Género",
        "Data de Nascimento",
        "Idade",
        "Qr Code",
        "Desconto",
        "Source",
        "Data de inscrição",
        "Observações",
        "Medium",
        "Estado",
      ];

      // Mapear os dados para corresponder aos headers
      const formattedData = this.table.map((item) => ({
        Nome: item.nome,
        NIF: item.nif,
        Telefone: item.telefone,
        Email: item.email,
        "Género": item.sexo,
        "Data de Nascimento": item.data_nascimento,
        "Idade": _this.calcularIdade(item.data_nascimento),
        "Qr Code": item.qr_code,
        Desconto: item.desconto,
        Source: item.utm_campaign,
        "Data de inscrição": item.dt_created,
        Observações: item.obs || "", // Substituir null por string vazia
        Medium: item.utm_medium,
        Estado: item.estado,
      }));
      // Converter os dados para CSV usando PapaParse
      const csv = Papa.unparse(formattedData, {
        header: true,
        columns: headers,
      });

      // Criar uma planilha a partir do CSV
      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        header: headers,
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

      // Gerar o arquivo XLSX e fazer o download
      XLSX.writeFile(workbook, "Export_Cartões.xlsx");
    },
    calcularIdade(dataNascimentoStr) {
      const hoje = new Date();
      const nascimento = new Date(dataNascimentoStr);
      let idade = hoje.getFullYear() - nascimento.getFullYear();
      const m = hoje.getMonth() - nascimento.getMonth();
      if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
      }
      if (idade < 0) {
        return 0;
      } else {
        return idade;
      }
      return idade;
    },
  },
  created() {
    // Inicializa a tabela filtrada com todos os dados
    this.filteredTable = [...this.table];
  },
  async mounted() {
    await this.inicio();
    this.filteredTable = [...this.table];
    this.i18n = this.$i18n;
    if (this.enableRTL) {
      this.i18n.locale = "ar";
      this.$rtl.enableRTL();
    }
  },
  beforeDestroy() {
    if (this.$rtl.isRTL) {
      this.i18n.locale = "en";
      this.$rtl.disableRTL();
    }
  },
};
</script>
<style>
#worldMap .datamap {
  left: 0 !important;
}
button.close {
  z-index: 999999999 !important;
}
.search-wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
}
</style>
